import * as React from 'react'

const TrashGreyIcon = (props: { className?: string; onClick?: (e: any) => void }) => {
  return (
    <svg
      onClick={props.onClick}
      className={'icon ' + props.className}
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='12' height='12' fill='black' fillOpacity='0' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.5 10.667C1.5 11.4004 2.1748 12 3 12H9C9.82422 12 10.499 11.4004 10.499 10.667V2.66699H1.5V10.667ZM11.249 0.666992H8.625L7.875 0H4.125L3.375 0.666992H0.75V2H11.249V0.666992ZM3.74902 10V4H4.74902V10H3.74902ZM7.49902 4V10H8.49902V4H7.49902Z'
        fill='#8C97A2'
      />
    </svg>
  )
}

export default TrashGreyIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/TrashGrey.tsx